import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { smartDate } from "@/lib/date";
import { cn } from "@/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPen,
  faPen,
  faPlus,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";

type DatesDisplayProps = {
  dateCreated: string;
  dateUpdated: string;
  className?: string;
};

export const DatesDisplay = ({
  dateCreated,
  dateUpdated,
  className,
}: DatesDisplayProps) => {
  const dateCreatedObj = new Date(dateCreated);
  const dateUpdatedObj = new Date(dateUpdated);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={cn("flex items-center gap-2", className)}>
          <FontAwesomeIcon icon={faCalendarPen} />
          {smartDate(dateUpdated)}
        </div>
      </TooltipTrigger>
      <TooltipContent className="flex flex-col gap-2">
        <div className="flex flex-row gap-2">
          <div>
            <FontAwesomeIcon icon={faPlus} />
          </div>
          <div className="w-18">Created at:</div>
          <div className="grow">{dateCreatedObj.toLocaleString()}</div>
        </div>

        <div className="flex flex-row gap-2">
          <div>
            <FontAwesomeIcon icon={faPen} />
          </div>
          <div className="w-18">Updated at:</div>
          <div className="grow">{dateUpdatedObj.toLocaleString()}</div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
